import { __rest } from "tslib";
import React from "react";
import moment from "moment";
import CalendarPart from "../calendar/CalendarPart";
import { Button } from "../button";
import { useTranslation } from "../i18n";
import { useConfig } from "../_util/config-context";
function hasValue(value) {
    if (Array.isArray(value)) {
        return moment.isMoment(value[0]) && moment.isMoment(value[1]);
    }
    return moment.isMoment(value);
}
export function CalendarWrapper(_a) {
    var onOk = _a.onOk, children = _a.children, props = __rest(_a, ["onOk", "children"]);
    var t = useTranslation();
    var classPrefix = useConfig().classPrefix;
    var value = props.value, type = props.type, onTypeChange = props.onTypeChange, showTime = props.showTime;
    if (!showTime) {
        return React.createElement(CalendarPart.Body, null, children(props));
    }
    function setType(value) {
        if (Array.isArray(type)) {
            onTypeChange([value, value]);
            return;
        }
        onTypeChange(value);
    }
    function isTimeType() {
        if (Array.isArray(type)) {
            return type[0] === "time" && type[1] === "time";
        }
        return type === "time";
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(CalendarPart.Body, null, children(props)),
        React.createElement(CalendarPart.Footer, { left: React.createElement("div", { className: classPrefix + "-date-status" }, isTimeType() ? (React.createElement(Button, { type: "link", htmlType: "button", onClick: function () { return setType("date"); }, style: { textDecoration: "none" } }, t.selectDate)) : (React.createElement(Button, { type: "link", htmlType: "button", onClick: function () { return setType("time"); }, disabled: !hasValue(value), style: { textDecoration: "none" } }, t.selectTime))), right: React.createElement(Button, { type: "primary", htmlType: "button", onClick: onOk, disabled: !hasValue(value) }, t.okText) })));
}
CalendarWrapper.displayName = "CalendarWrapper";
//# sourceMappingURL=CalendarWrapper.js.map